import { newProductKeyType } from '../../interfaces/Element.interfaces';
import { browserStorage } from '../browserStorage.util';
import { isWithinNewProductPeriod } from '../calculator/calculateDate.util';

export const checkHasNewProductNotification = ({
  id,
  startOnSaleDate,
  key,
}: {
  id?: string;
  startOnSaleDate?: Date;
  key: newProductKeyType;
}) => {
  if (!id || !startOnSaleDate) {
    return false;
  }

  if (!isWithinNewProductPeriod(startOnSaleDate)) {
    return false;
  }

  const prevNotificationString = browserStorage.getItem({ storageType: 'localStorage', itemKey: key });
  const prevNotification = prevNotificationString ? JSON.parse(prevNotificationString) : null;

  const isSameNotification =
    prevNotification && prevNotification.id === id && prevNotification.startOnSaleDate === startOnSaleDate;

  if (isSameNotification) {
    return false;
  }

  return true;
};
